var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedInIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41748 9.33984H1.07544V26.5992H6.41748V9.33984Z",
    fill: "#283288"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72149 7.08158C5.46642 7.08158 6.88 5.65343 6.88 3.89626C6.88 2.13909 5.46642 0.710938 3.72149 0.710938C1.97657 0.710938 0.562988 2.1367 0.562988 3.89626C0.562988 5.65582 1.97657 7.08158 3.72149 7.08158Z",
    fill: "#283288"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9564 17.5411C14.9564 15.114 16.072 13.6692 18.2102 13.6692C20.1745 13.6692 21.1184 15.0568 21.1184 17.5411V26.6012H26.4342V15.6719C26.4342 11.0489 23.8145 8.8125 20.1554 8.8125C16.4963 8.8125 14.954 11.664 14.954 11.664V9.33941H9.82886V26.5988H14.954V17.5388L14.9564 17.5411Z",
    fill: "#283288"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInIcon);
export default __webpack_public_path__ + "static/media/LinkedInIcon.48be1d3f86a659761cd0e97ccd7b94a9.svg";
export { ForwardRef as ReactComponent };